import { defineStore } from 'pinia'

const SESSION_STORAGE_KEY = 'pinia:session'

export const useSession = defineStore('session', {
	state: () => ({
		data: loadFromSessionStorage(), // โหลดตอน init
	}),

	getters: {
		get: (state) => {
			return (key: string): any => state.data[key]
		},
	},

	actions: {
		set(key: string, value: any) {
			this.data[key] = value
			saveToSessionStorage(this.data)
		},
		delete(key: string) {
			if (key in this.data) {
				delete this.data[key]
				saveToSessionStorage(this.data)
			}
		},
		clearAll() {
			this.data = {}
			sessionStorage.removeItem(SESSION_STORAGE_KEY)
		},
	},
})

function loadFromSessionStorage(): Record<string, any> {
	try {
		const stored = sessionStorage.getItem(SESSION_STORAGE_KEY)
		if (stored) {
			return JSON.parse(stored)
		}
	} catch (e) {
		console.warn('Failed to load sessionStorage:', e)
	}
	return {}
}

function saveToSessionStorage(data: Record<string, any>) {
	try {
		sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(data))
	} catch (e) {
		console.warn('Failed to save to sessionStorage:', e)
	}
}
